import styled from 'styled-components';
import {
  space,
  layout,
  color, SpaceProps, LayoutProps, ColorProps
} from 'styled-system';

interface VerticalDividerProps extends SpaceProps, LayoutProps, ColorProps{}

export const VerticalDivider = styled.div<VerticalDividerProps>`
  display: inline-block;
  margin: 0 10px;
  border-right: 1px solid #828282;
  height: 14px;
  ${space}
  ${layout}
  ${color}
`